export default "__VITE_ASSET__80b620be__"